import artifact from '$houdini/artifacts/CreateGroup'
import { MutationStore } from '../runtime/stores/mutation'

export class CreateGroupStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
